var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.type == 'col')?_c('div',{staticClass:"col-md"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }